import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import { getPortfolioAccounts } from 'services/portfolios';
import { TPortfolio, TGetPortfolioAccounts } from '@dekafvv/sharedfrontend';
import { getPortfolioDetails } from '../migratedCalls';

export const useGetPortfolioDetails = ({
    clientId,
    portfolioId,
    refetchOnMount = true,
    keys = '',
    enabled = true,
}: {
  clientId: string;
  portfolioId: string | number;
  refetchOnMount?: boolean;
  keys?: string[] | string;
  enabled?: boolean
}) => {
    const query = useQuery<
    AxiosResponse<TPortfolio>,
    null | { message: string },
    TPortfolio
  >({
      queryKey: [
          'getPortfolioDetails',
          'shared',
          clientId,
          portfolioId,
          ...(Array.isArray(keys) ? keys : [keys]),
      ],
      queryFn: () => getPortfolioDetails(clientId, portfolioId).then(({ data }) => data),
      refetchOnWindowFocus: false,
      refetchOnMount,
      enabled,
  });

    return query;
};

export const useGetPortfolioAccounts = ({
    clientId,
    portfolioId,
    refetchOnMount = true,
    enabled = true,
}: {
  clientId: string;
  portfolioId: string | number;
  refetchOnMount?: boolean;
  enabled?: boolean
}) => {
    const query = useQuery<
    AxiosResponse<TGetPortfolioAccounts>,
    null | { message: string },
    TGetPortfolioAccounts
  >({
      queryKey: ['getPortfolioAccounts', 'shared', clientId, portfolioId],
      queryFn: () => getPortfolioAccounts(clientId, portfolioId).then(({ data }) => data),
      refetchOnWindowFocus: false,
      refetchOnMount,
      enabled,
  });

    return query;
};
